/** Keep snapshot redraws out of the interval between touch release and its compatibility click. */
export class PointerClickGate {
 held=false;
 private timer:ReturnType<typeof setTimeout>|undefined;
 constructor(private refresh:()=>void){}
 press():void{this.cancel();this.held=true;}
 release(pointerType:string):void{if(!this.held)return;this.cancel();this.timer=setTimeout(()=>{this.timer=undefined;this.held=false;this.refresh();},pointerType==='touch'?350:0);}
 click():void{this.cancel();this.held=false;}
 destroy():void{this.cancel();this.held=false;}
 private cancel():void{if(this.timer!==undefined)clearTimeout(this.timer);this.timer=undefined;}
}
